import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette:{
        primary: {
            main: "#5AB0FF"
        },
    },
    typography : {
        fontFamily : "Lato"
    }
})

export default theme